import React from "react";
import styles from "./task-card.module.css";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { TaskType } from "../../enums/taskTypes";

interface LayoutProps {
  taskId: string;
  taskType: TaskType;
  isSwiping: boolean;
  onShowTaskDetails: (taskId: string, taskType: TaskType) => void;
  children: React.ReactNode;
}

export const Layout = ({
  taskId,
  taskType,
  isSwiping,
  onShowTaskDetails,
  children,
}: LayoutProps) => {
  return (
    <div
      className={styles["layout"]}
      onClick={() => {
        if (!isSwiping) {
          onShowTaskDetails(taskId, taskType);
          trackerHelper.trackActivityTaskCardClick();
        } else {
          return;
        }
      }}
    >
      {children}
    </div>
  );
};
